// A list of file extensions of files that can't be edited in the visual editor
export const sourceOnlyExtensions = ['.css', '.js', '.json', '.txt'];
